import React from 'react';

const card = {
  background: '#fff',
  borderRadius: 10,
  padding: 24,
  marginBottom: 16,
  boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
};

const label = {
  fontSize: 13,
  fontWeight: 600,
  marginBottom: 6,
  display: 'block',
};

const selectStyle = {
  fontSize: 13,
  padding: '8px 12px',
  border: '1px solid #e2e8f0',
  borderRadius: 6,
  width: '100%',
  boxSizing: 'border-box',
  background: '#fff',
};

const inputBase = {
  fontSize: 13,
  padding: '8px 12px',
  border: '1px solid #e2e8f0',
  borderRadius: 6,
  width: '100%',
  boxSizing: 'border-box',
};

export default function FreightTab({
  route, setRoute, custMiles, setCustMiles,
  freightMode, setFreightMode, miles, ratePerMile, baseFrt, totalFreight,
  NS, C, fmt, btn, FREIGHT_ROUTES,
}) {
  // FREIGHT_ROUTES is an object keyed by route name; treat the "Custom Route"
  // key as the trigger for the manual-miles input.
  const isCustom = route === 'Custom Route';
  const fuelSurcharge = baseFrt * 0.28;
  const accessorials = NS >= 3 ? 350 : 0;
  // freightMode is the lowercase FREIGHT_RATES key ('ftl_flatbed' / 'ftl_van' / 'ltl').
  const liftgate = freightMode === 'ltl' ? 150 : 0;

  // Display label ↔ FREIGHT_RATES key. App.jsx uses the keys; we show the labels.
  const MODES = [
    { value: 'ftl_flatbed', label: 'FTL Flatbed' },
    { value: 'ftl_van',     label: 'FTL Van' },
    { value: 'ltl',         label: 'LTL' },
  ];

  return (
    <div style={{ maxWidth: 800, margin: '0 auto' }}>
      {/* Route Selection */}
      <div style={card}>
        <span style={label}>Freight Route</span>
        <select
          value={route}
          onChange={(e) => setRoute(e.target.value)}
          style={selectStyle}
        >
          {Object.entries(FREIGHT_ROUTES).map(([name, data]) => (
            <option key={name} value={name}>
              {name}{data && data.miles ? ` (${data.miles} mi)` : ''}
            </option>
          ))}
        </select>

        {isCustom && (
          <div style={{ marginTop: 12 }}>
            <span style={label}>Custom Miles</span>
            <input
              type="number"
              value={custMiles}
              onChange={(e) => setCustMiles(Number(e.target.value))}
              placeholder="Enter miles"
              style={inputBase}
            />
          </div>
        )}
      </div>

      {/* Freight Mode */}
      <div style={card}>
        <span style={label}>Freight Mode</span>
        <div style={{ display: 'flex', gap: 8 }}>
          {MODES.map(({ value, label: modeLabel }) => {
            const active = freightMode === value;
            return (
              <button
                key={value}
                type="button"
                onClick={() => setFreightMode(value)}
                style={{
                  fontSize: 13,
                  fontWeight: active ? 700 : 400,
                  padding: '8px 20px',
                  border: active ? 'none' : '1px solid #e2e8f0',
                  borderRadius: 6,
                  background: active ? (C.blue || '#2563eb') : '#f8fafc',
                  color: active ? '#fff' : '#334155',
                  cursor: 'pointer',
                }}
              >
                {modeLabel}
              </button>
            );
          })}
        </div>
      </div>

      {/* Cost Breakdown */}
      <div style={card}>
        <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 14 }}>Cost Breakdown</div>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <tbody>
            <tr>
              <td style={{ fontSize: 13, padding: '6px 0', color: '#64748b' }}>Distance</td>
              <td style={{ fontSize: 13, padding: '6px 0', textAlign: 'right', fontWeight: 600 }}>{miles} miles</td>
            </tr>
            <tr>
              <td style={{ fontSize: 13, padding: '6px 0', color: '#64748b' }}>Rate per Mile</td>
              <td style={{ fontSize: 13, padding: '6px 0', textAlign: 'right', fontWeight: 600 }}>{fmt(ratePerMile || 0)}</td>
            </tr>
            <tr style={{ borderTop: '1px solid #e2e8f0' }}>
              <td style={{ fontSize: 13, padding: '6px 0', color: '#64748b' }}>Base Freight</td>
              <td style={{ fontSize: 13, padding: '6px 0', textAlign: 'right', fontWeight: 600 }}>{fmt(baseFrt || 0)}</td>
            </tr>
            <tr>
              <td style={{ fontSize: 13, padding: '6px 0', color: '#64748b' }}>Fuel Surcharge (28%)</td>
              <td style={{ fontSize: 13, padding: '6px 0', textAlign: 'right', fontWeight: 600 }}>{fmt(fuelSurcharge)}</td>
            </tr>
            <tr>
              <td style={{ fontSize: 13, padding: '6px 0', color: '#64748b' }}>Accessorials</td>
              <td style={{ fontSize: 13, padding: '6px 0', textAlign: 'right', fontWeight: 600 }}>{fmt(accessorials)}</td>
            </tr>
            {freightMode === 'ltl' && (
              <tr>
                <td style={{ fontSize: 13, padding: '6px 0', color: '#64748b' }}>Liftgate</td>
                <td style={{ fontSize: 13, padding: '6px 0', textAlign: 'right', fontWeight: 600 }}>{fmt(liftgate)}</td>
              </tr>
            )}
          </tbody>
        </table>

        <div
          style={{
            marginTop: 14,
            paddingTop: 14,
            borderTop: '2px solid #e2e8f0',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <span style={{ fontSize: 14, fontWeight: 700 }}>Total Freight</span>
          <span style={{ fontSize: 22, fontWeight: 700, color: C.blue || '#2563eb' }}>{fmt(totalFreight)}</span>
        </div>
      </div>

      {/* Sections note */}
      <div style={{ ...card, fontSize: 12, color: '#64748b' }}>
        Sections: <strong>{NS}</strong> &nbsp;|&nbsp; Mode: <strong>{freightMode}</strong>
      </div>
    </div>
  );
}
